import {ActionCreatorDefinition, createAction} from "redux-ts";
import {TSMap} from "typescript-map";
import {Lesson, TutorialCategory} from "protocol/config/GetUIConfigurationResponse";

export const FetchUIConfigurationType: string = "FetchUIConfiguration";
export const SetLessonsType: string = "SetLessons";
export const OptInLessonType: string = "OptInLesson";
export const SetLessonType: string = "SetLesson";
export const RequestEnableEbookType: string = "RequestEnableEbook";

export interface SetLessonsPayload {

    categories: TutorialCategory[];
    lessons: TSMap<number, Lesson[]>;
    EbookUrl: string;
}

export interface OptInLessonPayload {

    lesson: Lesson;
}

export interface SetLessonPayload {
    lesson: Lesson;
}

export const FetchUIConfiguration: ActionCreatorDefinition<any, any> = createAction<any>(FetchUIConfigurationType);
export const SetLessons: ActionCreatorDefinition<SetLessonsPayload, any> = createAction<SetLessonsPayload>(SetLessonsType);
export const OptInLesson: ActionCreatorDefinition<OptInLessonPayload, any> = createAction<OptInLessonPayload>(OptInLessonType);
export const SetLesson: ActionCreatorDefinition<SetLessonPayload, any> = createAction<SetLessonPayload>(SetLessonType);
export const RequestEnableEbook: ActionCreatorDefinition<any, any> = createAction<any>(RequestEnableEbookType);
